import { createSlice } from '@reduxjs/toolkit';

const RoleDetailsDataSlice = createSlice({
    name: 'RoleDetailsData',
    initialState: '',
    reducers: {
        setRoleDetailsData: (state, action) => {            
            return action.payload;
        },
        resetRoleDetailsData: (state) => {
            return null;
        },
    },
});

export const { setRoleDetailsData, resetRoleDetailsData } = RoleDetailsDataSlice.actions;
export default RoleDetailsDataSlice.reducer;